var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEyeClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 13,
    viewBox: "0 0 28 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 1C22.15 4 18.9597 7 14.5 7C10.0403 7 6.85 4 6 1",
    stroke: "#090110",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 4.5,
    r: 1.5,
    fill: "#090110"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 9.5,
    r: 1.5,
    fill: "#090110"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 11.5,
    r: 1.5,
    fill: "#090110"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 9.5,
    r: 1.5,
    fill: "#090110"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 4.5,
    r: 1.5,
    fill: "#090110"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeClosed);
export default __webpack_public_path__ + "static/media/icon_eye_closed.6f13a3a262e22d7011cd97b1dfbf6f56.svg";
export { ForwardRef as ReactComponent };